export default "__VITE_ASSET__CjRXpwIh__"